// removed by extract-text-webpack-plugin
module.exports = {"root":"lGnYK","marginTop":"_3bfyN"};


//////////////////
// WEBPACK FOOTER
// ../source/views/Signup/styles.css
// module id = 1682
// module chunks = 11